var angular = require('angular');
require('angulartics');

angular.module('angulartics.console', ['angulartics'])
.config([
    '$analyticsProvider',

    function configAngularticsConsole($analyticsProvider) {
        var $log =  angular.injector(['ng']).get('$log');

        $analyticsProvider.registerSetUsername(function (username) {
            $log.debug('registerSetUsername', username);
        });

        $analyticsProvider.registerSetAlias(function (alias) {
            $log.debug('registerSetAlias', alias);
        });

        $analyticsProvider.registerSetSuperPropertiesOnce(function (properties) {
            $log.debug('registerSetSuperPropertiesOnce', properties);
        });

        $analyticsProvider.registerSetSuperProperties(function (properties) {
            $log.debug('registerSetSuperProperties', properties);
        });

        $analyticsProvider.registerSetUserPropertiesOnce(function (properties) {
            $log.debug('registerSetUserPropertiesOnce', properties);
        });

        $analyticsProvider.registerSetUserProperties(function (properties) {
            $log.debug('registerSetUserProperties', properties);
        });

        $analyticsProvider.registerPageTrack(function (path) {
            $log.debug('registerPageTrack', path);
        });

        $analyticsProvider.registerEventTrack(function (action, properties) {
            $log.debug('registerEventTrack', action, properties);
        });

        $analyticsProvider.registerIncrementProperty(function (property, value) {
            if (typeof value === 'undefined') {
                $log.debug('registerIncrementProperty', property);
            } else {
                $log.debug('registerIncrementProperty', property, value);
            }
        });

        $analyticsProvider.registerUserTimings(function (action, properties) {
            $log.debug('registerUserTimings', action, properties);
        });
    }
]);
